import * as firebase from "firebase"

export const loginAction = (email, password) => async (dispatch) => {
  firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then((user) => {
      // if (!user.user.emailVerified) {
      //   console.log(firebase.auth().currentUser);
      //   return firebase.auth().currentUser.sendEmailVerification()
      //   .then(function() {
      //     // Email sent.
      //     console.log('Verification Email Sent');
      //   })
      //   .catch(function(err) {
      //     // An error happened.
      //     console.log(`Verification Email Not Sent. Error:\n${err}`);
      //   });
      // }
      dispatch({ type: "login", payload: true })
    })
    .catch(function (err) {
      dispatch({ type: "login_failed", payload: "failed", err })
    })
}

export const loginWithGoogle = () => {
  return (dispatch, getState, { getFirestore }) => {
    const provider = new firebase.auth.GoogleAuthProvider()
    provider.addScope("profile")
    provider.addScope("email")
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        // result.credential.accessToken
        // result.user
        if (result.additionalUserInfo.isNewUser && result.user) {
          // console.log('Debug-1');
          const firestore = getFirestore()
          const user = result.user

          console.log(user)

          return firestore
            .collection("customers")
            .doc(user.uid)
            .set({
              name: user.displayName,
              email: user.email,
              photoURL: user.photoURL,
              time: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(() => {
              dispatch({ type: "login", payload: true })
              // console.log('Customer Successfully Created.');
            })
            .catch((err) => {
              // console.log(`Error Creating Customer. Error:\n${err}`);
            })
        }
        window.location.replace("/d/dashboard")
      })
      .then(() => {}) // Create Customer/Merchant In Database If It Doesn't Exist
      .catch((err) => {
        console.log(`Error Signing In With Google. Error:\n${err}`)
        // error.code
        // error.message
        // error.email
        // error.credential
      })
  }
}

export const loginWithFacebook = () => {
  return (dispatch, getState, { getFirestore }) => {
    const provider = new firebase.auth.FacebookAuthProvider()
    provider.addScope("profile")
    provider.addScope("email")
    firebase.auth().signInWithPopup(provider)
  }
}

export const resetPassword = (email) => {
  return (dispatch, getState, { getFirestore }) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((res) => {
        dispatch({ type: "password_reset_success", payload: "success", res })
      })
      .catch((err) => {
        dispatch({ type: "password_reset_error", payload: "failed", err })
      })
  }
}
